import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ListMyHomeState {

  private searchAddressSub$ = new BehaviorSubject<any>(null);
  searchAddress = this.searchAddressSub$.asObservable();

  public get searchAddressValue() {
    return this.searchAddressSub$.getValue();
  }
  public set searchAddressValue(address: any) {
    this.searchAddressSub$.next(address);
  }

  private propertyDetailsSub$ = new BehaviorSubject<any>(null);
  propertyDetails = this.propertyDetailsSub$.asObservable();

  public get propertyDetailsValue() {
    return this.propertyDetailsSub$.getValue();
  }
  public set propertyDetailsValue(details: any) {
    this.propertyDetailsSub$.next(details);
  }

  private listingsDetailsSub$ = new BehaviorSubject<any>(null);
  listingsDetails = this.listingsDetailsSub$.asObservable();

  public get listingsDetailsValue() {
    return this.listingsDetailsSub$.getValue();
  }
  public set listingsDetailsValue(details: any) {
    this.listingsDetailsSub$.next(details);
  }

}